import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { IEntityVersionSearchParams } from '../../../api/requests/entities/entityVersionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useEntitiesCountResult {
    isLoaded: boolean;
    count: number | null;
}

export const useEntitiesCount = (searchParams: IEntityVersionSearchParams) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useEntitiesCountResult>({ isLoaded: false, count: null });

    useEffect(() => {

        if (rootStore.categoryStore.currentCategory != null && rootStore.kindVersionStore.currentKindVersion != null) {
            setResult({ isLoaded: false, count: null });


            rootStore.entityVersionStore.countCurrentEntityVersionsForCurrentKind(searchParams)
                .then((count) => {
                    setResult({ isLoaded: true, count: count });
                })
                .catch(e =>
                    publishNotification({
                        text: 'Error counting entities',
                        canClose: true
                    })
                );
        }
    }, [rootStore.entityVersionStore, publishNotification, searchParams, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
